import React from 'react';
import FilterTable from './filterTable';
import {complexColumn} from './tableUtils';

const PermanentLicenseHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: (column, colIndex) => {
      return {width: '18%'}
    }
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
    headerStyle: (column, colIndex) => {
      return {width: '10%'}
    }
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
    headerStyle: (column, colIndex) => {
      return {width: '10%'}
    }
  }, {
    dataField: 'info',
    text: 'Info',
    sort: true,
    filter_: { type: 'text' }
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="permanentLicensesHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        info: complexColumn(histrec, [{
          fields: 'device.key',
          label: 'Device key'
        }, {
          fields: 'feature.name',
          label: 'Feature'
        }, {
          fields: 'relatedLicense.key',
          label: 'Previous license',
          condition: histrec => histrec.eventName === 'Generation'
        }, {
          fields: 'relatedLicense.key',
          label: 'Next license',
          condition: histrec => histrec.eventName === 'Changing'
        }, {
          fields: 'previousSupportDayCount',
          label: 'Previous support day count',
          condition: histrec => histrec.eventName === 'Update support period changing'
        }])
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no permanent license history records"
    />
  );
};

export default PermanentLicenseHistoryTable;



// WEBPACK FOOTER //
// ./src/components/permanentLicenseHistoryTable.js